<style scoped>
.required {
  color: #b71c1c !important;
}
</style>

<template>
  <v-text-field
    dense
    outlined
    hide-details="auto"
    :class="computedClass"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <template v-slot:label>
      {{ $attrs.label }} <span class="required" v-if="required"> *</span>
    </template>
  </v-text-field>
</template>

<script>
import requiredMixin from '../../../mixins/utils/form/requiredMixin';

export default {
  name: 'AnchorTextField',
  mixins: [requiredMixin],
  computed: {
    computedClass: vm => {
      const classes = vm.$attrs.classes || '';
      const dft = classes.includes('mb-') ? '' : 'mb-2';
      return `${classes} ${dft}`.trim();
    },
  },
};
</script>
